"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Payment_1 = require("./Payment");
var useAppContext_1 = require("../../common/react/useAppContext");
var CustomerValidationErrorText_1 = require("./staticText/CustomerValidationErrorText");
var PaymentStyles_1 = require("./paymentProviders/apexx/PaymentStyles");
var MainHeaderWithBackLink_1 = require("../../common/components/presentation/MainHeader/MainHeaderWithBackLink");
var PaymentPage = function () {
    var _a;
    var activateMainTitle = core_1.useTheme().checkoutLite.common.activateMainTitle;
    var translationId = !!activateMainTitle ? 'payment.mainTitle' : 'journeyType.checkoutReserveOnline';
    var deal = useAppContext_1.default().deal;
    var style = PaymentStyles_1.default();
    var isCustomerValidated = ((_a = deal.extraFields) === null || _a === void 0 ? void 0 : _a.is_customer_validated) !== false;
    return (<>
      <MainHeaderWithBackLink_1.default titleTranslation={translationId} withBackLink={true}/>
      <core_1.Container data-test={'container:checkout:payment'}>
        {isCustomerValidated && <Payment_1.default />}
        {!isCustomerValidated && <CustomerValidationErrorText_1.default style={style}/>}
      </core_1.Container>
    </>);
};
exports.default = PaymentPage;
